/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, FragmentsDeliveryGetStationConfigAllStationsConfigs401, FragmentsDeliveryGetStationConfigAllStationsConfigs403 } from "../models/FragmentsDeliveryGetStationConfigAllStationsConfigs";

export function getFragmentsDeliveryGetStationConfigAllStationsConfigsUrl() {
  const res = { method: 'GET', url: `/fragments-delivery/v1/station-config/all` as const }
  return res
}

/**
 * @summary Get all Station configs for a client (client access)
 * {@link /fragments-delivery/v1/station-config/all}
 */
export async function fragmentsDeliveryGetStationConfigAllStationsConfigs(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigAllStationsConfigs401 | FragmentsDeliveryGetStationConfigAllStationsConfigs403>, unknown>({ method : "GET", url : getFragmentsDeliveryGetStationConfigAllStationsConfigsUrl().url.toString(), ... requestConfig })
  return res.data
}